import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { ILMSButton } from '../../../components/ILMSButton';

export function SaveBar({ canEdit, dirty, saving, saved, onSave, onReset, resetLabel = 'Back to defaults', saveLabel = 'Save' }: {
  canEdit: boolean;
  dirty: boolean;
  saving: boolean;
  saved?: boolean;
  onSave: () => void;
  onReset?: () => void;
  resetLabel?: string;
  saveLabel?: string;
}) {
  if (!canEdit) return <p className="text-helper-text text-ink-500">Only users who can edit Settings can change these.</p>;
  return (
    <div className="sticky bottom-0 -mx-1 flex flex-wrap items-center gap-2 border-t border-ink-300/15 bg-white/95 px-1 py-3 backdrop-blur">
      <ILMSButton onClick={onSave} loading={saving} disabled={!dirty}>{saveLabel}</ILMSButton>
      {onReset && <ILMSButton variant="ghost" onClick={onReset}>{resetLabel}</ILMSButton>}
      {dirty ? <span className="text-helper-text text-warning-700">Unsaved changes</span>
        : saved && <span className="inline-flex items-center gap-1 text-helper-text text-success-700"><CheckCircle2 className="h-4 w-4" /> Saved — others see it the next time they open the app or website</span>}
    </div>
  );
}
